<template>
  <!-- 信号值图形 -->
  <div class="signal">
    <div v-for="index in 5" :key="index" :class="getBarClass(index)"></div>
  </div>
</template>
<script>
export default {
  props: {
    // 信号强度
    strength: {
      default: 0
    }
  },
  data() {
    return {
      limit: {
        1: 10,
        2: 40,
        3: 60,
        4: 80,
        5: 95
      }
    }
  },
  methods: {
    // 计算柱状块样式类
    getBarClass(index) {
      let classList = [`bar-${index}`]
      if (this.strength >= this.limit[index]) {
        classList.push('active')
      }
      return classList
    }
  },
}
</script>
<style lang="less" scoped>
@import url("../assets/css/mixin.less");
.signal {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  .bar {
    width: 4px;
    background: @borderColor;
    margin: 0 1px;
    &.active {
      background: @themeColor;
    }
  }
  --bar-height: 4px; 
  .bar-1 {
    .bar;
    height: var(--bar-height);
  }
  .bar-2 {
    .bar;
    height: calc(2 * var(--bar-height) - 2px);
  }
  .bar-3 {
    .bar;
    height: calc(3 * var(--bar-height) - 1px);
  }
  .bar-4 {
    .bar;
    height: calc(4 * var(--bar-height));
  }
  .bar-5 {
    .bar;
    height: calc(5 * var(--bar-height) + 2px);
  }
}
</style>